import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { RAGL_MANUAL_ENTRY_BASE_PATH } from '../../../../../../../../features/clearing-ledger/manual-entry/ragl-manual-entry-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/journal/_manual-entry')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'ragl-manual-entry-list',
        label: 'Journals',
        to: RAGL_MANUAL_ENTRY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
